"use strict";

var _slicedToArray = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var fuse_js_1 = __importDefault(require("fuse.js"));

var DisplayComponents_1 = require("./DisplayComponents");

var TypeaheadResult_1 = __importDefault(require("./TypeaheadResult"));

var library_ui_expander_1 = __importDefault(require("@talus-analytics/library.ui.expander"));

var Typeahead = function Typeahead(_ref) {
  var _ref$multiselect = _ref.multiselect,
      multiselect = _ref$multiselect === void 0 ? false : _ref$multiselect,
      items = _ref.items,
      values = _ref.values,
      onAdd = _ref.onAdd,
      onRemove = _ref.onRemove,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _ref$RenderItem = _ref.RenderItem,
      RenderItem = _ref$RenderItem === void 0 ? function (_ref2) {
    var item = _ref2.item,
        selected = _ref2.selected;
    return react_1.default.createElement(TypeaheadResult_1.default, Object.assign({}, {
      item: item,
      selected: selected
    }));
  } : _ref$RenderItem,
      _ref$searchKeys = _ref.searchKeys,
      searchKeys = _ref$searchKeys === void 0 ? ['key', 'label'] : _ref$searchKeys,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$ariaLabel = _ref.ariaLabel,
      ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel;

  var _a;

  if (!items) throw new Error('Item array in multiselect cannot be undefined');

  var _ref3 = (0, react_1.useState)(''),
      _ref4 = _slicedToArray(_ref3, 2),
      searchString = _ref4[0],
      setSearchString = _ref4[1];

  var _ref5 = (0, react_1.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      showResults = _ref6[0],
      setShowResults = _ref6[1];

  var inputRef = (0, react_1.useRef)(null); // compute fuzzy search

  var fuse = (0, react_1.useMemo)(function () {
    return new fuse_js_1.default(items, {
      keys: searchKeys
    });
  }, [items, searchKeys]);
  var results = fuse.search(searchString).map(function (_ref7) {
    var item = _ref7.item;
    return item;
  }); // accept top result if enter is pressed

  var handleKeyPress = function handleKeyPress(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (results[0] || items[0]) onAdd(results[0] || items[0]);
      inputRef.current.blur();
      setShowResults(false);
      setSearchString('');
    }
  }; // close results onBlur, but
  // not if a button is clicked


  var blurTimeout;

  var onBlurHandler = function onBlurHandler() {
    // set it to close next tick
    blurTimeout = setTimeout(function () {
      setShowResults(false);
      if (!values) setSearchString('');
    });
  }; // if focus is inside the container,
  // cancel the timer, don't close it


  var onFocusHandler = function onFocusHandler() {
    clearTimeout(blurTimeout);
    setShowResults(true);
    inputRef.current.focus();
  };

  (0, react_1.useEffect)(function () {
    var _a;

    if (values.length > 0 && !multiselect) setSearchString((_a = values[0]) === null || _a === void 0 ? void 0 : _a.label);
  }, [values, multiselect]);
  (0, react_1.useEffect)(function () {
    if (disabled && !values) setSearchString('');
  }, [disabled, values]);
  return react_1.default.createElement(DisplayComponents_1.Container, {
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    className: className,
    onSubmit: function onSubmit(e) {
      return e.preventDefault();
    },
    style: style
  }, react_1.default.createElement(DisplayComponents_1.SearchBar, {
    disabled: disabled,
    type: "search",
    autoComplete: "off",
    name: "special-auto-fill",
    ref: inputRef,
    onKeyPress: handleKeyPress,
    value: searchString,
    onChange: function onChange(e) {
      return setSearchString(e.target.value);
    },
    placeholder: placeholder,
    "aria-label": ariaLabel
  }), react_1.default.createElement(DisplayComponents_1.SearchIcon, {
    searchString: searchString
  }), react_1.default.createElement(library_ui_expander_1.default, {
    floating: true,
    open: showResults,
    style: {
      width: '100%'
    },
    animDuration: 125
  }, react_1.default.createElement(DisplayComponents_1.Results, null, multiselect && values.length > 0 && react_1.default.createElement(DisplayComponents_1.Selected, null, values.map(function (item) {
    return react_1.default.createElement(DisplayComponents_1.ItemButton, {
      key: item.key,
      onClick: function onClick() {
        return onRemove(item);
      }
    }, react_1.default.createElement(RenderItem, Object.assign({
      selected: true,
      key: item.key
    }, {
      item: item
    })));
  })), (results.length > 0 && searchString !== ((_a = values[0]) === null || _a === void 0 ? void 0 : _a.label) ? results : items).map(function (item) {
    return react_1.default.createElement(DisplayComponents_1.ItemButton, {
      key: item.key,
      onClick: function onClick() {
        return onAdd(item);
      }
    }, react_1.default.createElement(RenderItem, Object.assign({}, {
      item: item
    })));
  }))));
};

exports.default = Typeahead;